import API from '@/helpers/api';

export async function find(params = {}) {
  return API('/procedures', params).fetch();
}

export async function findById(id) {
  return API(`/procedures/${id}`).fetch();
}
